module.exports = __webpack_public_path__ + "img/hair_front_male_buzzed_mask.82eca1b0.png";